import React from 'react';
import './Tramites.css';

const Tramites = () => (
  <main className="tramites-page">
    <section className="tramites-header">
      <div className="tramites-container reveal-on-scroll">
        <h1>Tramites</h1>
        <p>
          En esta seccion vas a encontrar todos los tramites disponibles de la Direccion Provincial
          del Agua.
        </p>
      </div>
    </section>

    <section className="tramites-list">
      <div className="tramites-container tramites-grid">
        <article className="tramite-card coming-soon reveal-on-scroll">
          <h2>Ribera</h2>
          <p>Solicitud y seguimiento del tramite de linea de ribera.</p>
          <span className="tramite-link disabled">No disponible</span>
        </article>

        <article className="tramite-card coming-soon reveal-on-scroll">
          <h2>Proximamente</h2>
          <p>Se iran incorporando nuevos tramites digitales en esta seccion.</p>
          <span className="tramite-link disabled">No disponible</span>
        </article>
      </div>
    </section>
  </main>
);

export default Tramites;

